<template>
    <div>
        <h2>Business</h2>
    </div>
</template>

<script>

export default {
    name: "Business",
    setup() {
    }
}
</script>
